module.exports = __webpack_public_path__ + "img/invoices.6d1a91ce.svg";